import { type ReactNode } from "react";

interface MoveGroupProps {
  children: ReactNode;
}

const MoveGroup = ({ children }: MoveGroupProps) => {
  return <div className="flex flex-col gap-3">{children}</div>;
};

export default MoveGroup;
